import { Observable } from "rxjs";
import { Input } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { LangService } from "src/app/services/lang/lang.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MainService } from "src/app/services/api/main.service";
import { StorageService } from "src/app/services/storage.service";
import { SessionService } from "src/app/services/session.service";
import {
	AuthService,
	AuthServiceConfig,
	FacebookLoginProvider,
	GoogleLoginProvider,
	SocialUser,
} from "angularx-social-login";
import { environment } from "src/environments/environment";
import { CartService } from "src/app/services/api/cart.service";
import { SocialLoginService } from "src/app/services/social-login.service";

// <script src="https://accounts.google.com/gsi/client" async defer></script>

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
	@Input() resetPasswordModal: any = false;
	onClose: any;
	formGroup: FormGroup;

	email: any;
	password: any;
	retypePassword: any;
	remme: any;
	firstname: any;
	lastname: any;
	token: any;

	formDisplay: string = "signin"; /* signin or signup */

	constructor(
		public formBuilder: FormBuilder,
		public lang: LangService,
		public mainService: MainService,
		public storage: StorageService,
		public sessionService: SessionService,
		public authService: AuthService,
		public cartService: CartService,
		public socialLoginService: SocialLoginService
	) {
		
	}

  	ngOnInit() {
		let emailRe = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		this.formGroup = this.formBuilder.group(
			{
				email: [this.email, [Validators.required, Validators.pattern(emailRe)]],
				password: [
				this.password,
				[Validators.required, Validators.minLength(8)],
				],
				retypePassword: [
				this.retypePassword,
				[Validators.required, Validators.minLength(8)],
				],
				firstname: [this.firstname, [Validators.required]],
				lastname: [this.lastname, [Validators.required]],
				token: [this.token, [Validators.required]],
			},
			{}
		);

		this.socialLoginService.googleAccount.id.renderButton(document.getElementById("g_id_signin_click"), {
			theme: 'outline',
			size: 'large',
		});
		
		this.socialLoginService.promt();
  	}

	/**
	 * close login modal
	 */
	closeModal(fc: boolean = false) {
		let data = {
			forceClose: fc,
		};
		this.onClose(data);
	}

	/**
	 * close login modal
	 * @param forceLogin used after registration to force the
	 * get token of the user
	 */
	login(forceLogin: boolean = false) {
		if (!forceLogin) {
			if (this.formDisplay == "signup") {
				this.signUp();
			}

			if (this.formDisplay == "forgotpassword") {
				this.forgotPassword();
			}

			if (this.formDisplay == "resetpasstoken") {
				this.resetPassword();
			}
		}
		if (this.formDisplay == "signin" || forceLogin == true) {
			this.formGroup.controls.email.setValue(this.email);
			this.formGroup.controls.password.setValue(this.password);

			if (this.formGroup.controls.email.errors) {
				this.mainService.toastService.add(this.lang.getLang("l24"), "danger");
			} else if (this.formGroup.controls.password.errors) {
				this.mainService.toastService.add(this.lang.getLang("l25"), "danger");
			} else {
				this.socialLoginService.login(this.email, this.password).then(res => {
					if(!res){
						let el:any = document.getElementById('login-password');

						if(el.type == 'password'){
							this.showPassword('login-password', 'eye-password');
						}
					}
				});
				// this.mainService.setLoader(true);

				// let formData = new FormData();
				// formData.append("username", this.email);
				// formData.append("password", this.password);

				// this.mainService
				// .post("/rest/entrelable/V1/integration/customer/token", formData)
				// .subscribe(
				// 	(success) => {
				// 	let user = {
				// 		token: success,
				// 		isLogedIn: true,
				// 	};
				// 	if (this.remme) {
				// 		this.storage.setLocal("user", user, null);
				// 	} else {
				// 		this.storage.setSession("user", user);
				// 	}
				// 	this.assignGuestCartToCustomer();
				// 	/* window.location.reload(); */
				// 	},
				// 	(error) => this.mainService.errorHandler(error)
				// );
			}
		}
	}

//   assignGuestCartToCustomer() {
//     this.mainService
//       .makeRequest("/rest/entrelable/V1/customers/me", "", "GET")
//       .then((customer) => {
//         this.storage.get("guest_cart_id").then((guestCartId) => {
//           if (guestCartId) {
//             let c: any = customer;
//             let jsonData = {
//               customerId: c.id,
//               storeId: c.store_id,
//             };
//             this.mainService
//               .makeRequest(
//                 "/rest/entrelable/V1/guest-carts/" + guestCartId,
//                 jsonData,
//                 "PUT",
//                 false
//               )
//               .then((assingedCart) => {
//                 this.storage.removeItem("guest_cart_id");
//                 this.getCartIdAndSetUserData(customer);
//               });
//           } else {
//             this.getCartIdAndSetUserData(customer);
//           }
//         });
//       });
//   }

//   getCartIdAndSetUserData(customer) {
//     this.cartService.getCart().then((cart) => {
//       this.sessionService.userData = customer;
//       this.mainService.setLoader(false);
//       this.sessionService.checkLogin();
//       this.closeModal(false);
//       window.location.reload();
//     });
//   }

  /**
   * make an api call to send an reset password token to
   * customer's email address
   */
  forgotPassword() {
    this.formGroup.controls.email.setValue(this.email);

    if (this.formGroup.controls.email.errors) {
      this.mainService.toastService.add(this.lang.getLang("l24"), "danger");
    } else {
      this.mainService.setLoader(true);
      let jsonData = {
        email: this.email,
        template: "email_reset",
      };
      let header = {
        "Content-Type": "application/json; charset=utf-8",
      };

      this.mainService
        .put(
          "/rest/entrelable/V1/customers/password",
          JSON.stringify(jsonData),
          header
        )
        .subscribe(
          (success) => {
            if (success) {
              this.mainService.toastService.add(
                this.lang.getLang("l39"),
                "success"
              );
              this.changeForm("resetpasstoken");
            }
            this.mainService.setLoader(false);
          },
          (error) => {
            this.mainService.setLoader(false);
            this.mainService.toastService.add(
              "There is no customer associated with email " + this.email,
              "danger"
            );
          }
        );
    }
  }

  /**
   * make an api call to send an reset password token to
   * customer's email address
   */
  resetPassword() {
    this.formGroup.controls.token.setValue(this.token);
    this.formGroup.controls.password.setValue(this.password);
    this.formGroup.controls.email.setValue(this.email);

    if (this.formGroup.controls.token.errors) {
      this.mainService.toastService.add(this.lang.getLang("l40"), "danger");
    } else if (this.formGroup.controls.password.errors) {
      this.mainService.toastService.add(this.lang.getLang("l25"), "danger");
    } else if (this.formGroup.controls.email.errors) {
      this.mainService.toastService.add(this.lang.getLang("l24"), "danger");
    } else {
      this.mainService.setLoader(true);
      let jsonData = {
        email: this.email,
        resetToken: this.token,
        newPassword: this.password,
      };
      let header = {
        "Content-Type": "application/json; charset=utf-8",
      };

      this.mainService
        .post(
          "/rest/entrelable/V1/customers/resetPassword",
          JSON.stringify(jsonData),
          header
        )
        .subscribe(
          (success) => {
            if (success) {
              this.mainService.toastService.add(
                this.lang.getLang("l42"),
                "success"
              );
              this.changeForm("resetpasstoken");
              this.login(true);
            }
            this.mainService.setLoader(false);
          },
          (error) => this.resetPasswordError()
        );
    }
  }

	resetPasswordError() {
		this.mainService.toastService.add(this.lang.getLang("l41"), "danger");
		this.mainService.setLoader(false);
	}

	/**
	 * register a new user
	 */
	signUp() {
		this.formGroup.controls.email.setValue(this.email);
		this.formGroup.controls.password.setValue(this.password);
		this.formGroup.controls.retypePassword.setValue(this.retypePassword);
		this.formGroup.controls.firstname.setValue(this.firstname);
		this.formGroup.controls.lastname.setValue(this.lastname);

		if (this.formGroup.controls.email.errors) {
			this.mainService.toastService.add(this.lang.getLang("l24"), "danger");
		} else if (this.formGroup.controls.password.errors) {
			this.mainService.toastService.add(this.lang.getLang("l25"), "danger");
		} else if (this.formGroup.controls.firstname.errors) {
			this.mainService.toastService.add(this.lang.getLang("l32"), "danger");
		} else if (this.formGroup.controls.lastname.errors) {
			this.mainService.toastService.add(this.lang.getLang("l33"), "danger");
		} else {
			if (this.password === this.retypePassword) {
				this.mainService.setLoader(true);

				let jsonData = {
					customer: {
						store_id: 2,
						email: this.email,
						firstname: this.firstname,
						lastname: this.lastname,
						addresses: [],
					},
					password: this.password,
				};

				let header = {
					"Content-Type": "application/json; charset=utf-8",
				};

				this.mainService.post("/rest/entrelable/V1/customers", JSON.stringify(jsonData), header)
				.subscribe(
					(success) => {
						this.login(true);
					}, error => {
						if(error.error.message == 'A customer with the same email address already exists in an associated website.'){
							this.mainService.toastService.add(this.lang.getLang('A customer with the same email address already exists. Please try different email and try again.'), 'danger');
						}
						else if(error.error.message == '"Email" is not a valid email address.'){
							this.mainService.toastService.add(this.lang.getLang('{email} is not a valid email address.', {email: this.email}), 'danger');
						}
						this.mainService.setLoader(false);
				});
			} else {
				this.mainService.toastService.add(this.lang.getLang("l67"), "danger");
			}
		}
	}

	signInWithFB(): void {
		this.authService
		.signIn(FacebookLoginProvider.PROVIDER_ID)
		.then((result) => {
			let jsonData = {
				input_token: result.authToken,
				"provider": "FACEBOOK"
			} 
			this.socialLoginService.socialLogin(jsonData);
		});
	}

  	signInWithGoogle(): void {
		// this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then((result) => {
		// 	this.socialLoginService.socialLogin(result);
		// });
	}

	signOut(): void {
		this.socialLoginService.signOut();
	}

	/**
	 * change the form from login to sign up
	 */
	changeForm(form) {
		this.formDisplay = form;
	}

	showPassword(elId, eyElId){
		let el:any = document.getElementById(elId);
		let eyeEl:any = document.getElementById(eyElId);

		if(el.type == 'password'){
			el.type = "text";
			eyeEl.className = 'fas fa-eye-slash';
		} else {
			el.type = "password";
			eyeEl.className = 'fas fa-eye';
		}
	}
}
